/** What the store wants from imported data; it decides what must be found. */
export enum ApdmImportPurpose {
  /** Items and dates: enough to tell when maintenance comes due. */
  ServiceHistory = 'service_history',
  /** Dates alone: enough to tell when a customer was last seen. */
  VisitHistory = 'visit_history',
  /** Plates alone: who to reach, for a message to everyone listed. */
  ContactList = 'contact_list',
}

export enum ApdmImportStatus {
  Uploaded = 'uploaded',
  Summarized = 'summarized',
  Read = 'read',
  NeedsAnswer = 'needs_answer',
  Ready = 'ready',
  Publishing = 'publishing',
  Published = 'published',
  Failed = 'failed',
  Deleted = 'deleted',
}

export enum ApdmServiceCategoryKind {
  Routine = 'routine',
  NonRoutine = 'non_routine',
  Wash = 'wash',
}

export enum ApdmDueBasis {
  Explicit = 'explicit',
  Time = 'time',
  MileageEstimated = 'mileage_estimated',
  Undetermined = 'undetermined',
  Platform = 'platform',
}
